const ST_TOKEN = '3b983a7db26251dc78a3a842a75d79a4';
const SHOP_URL = '/api/2024-01/graphql.json';
const TOPE_MINIMO_B2B = 0; 

let localCart = [];

window.limpiarCarritoLocal = function() {
    localCart = [];
    actualizarMiniCarritoUI();
};

let zoomLevel = 1; 
let currentTranslateX = 0; 
let globalCatalogData = null; 
let isMobileMode = false;

let catalogProductsMap = {};
let modalCurrentHandle = null;
let modalCurrentVarId = null;
let modalCurrentQty = 1;
let modalCurrentUnitPrice = 0; 
let lastFocusedElement = null; 

function esProductoFora(node) {
    if (node.tags && Array.isArray(node.tags)) {
        return node.tags.some(tag => tag.toLowerCase() === 'fora');
    }
    return node.metafield && node.metafield.value === "true";
}

function cargarScript(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

function animarBadgeCarrito() {
    const badge = document.getElementById('cart-count');
    if (badge) {
        badge.classList.remove('pop-anim');
        void badge.offsetWidth; 
        badge.classList.add('pop-anim');
    }
}

async function abrirCatalogo(handle, imgP, imgC, titulo, tipoCatalogo) {
    document.getElementById('cat-title-header').innerText = titulo;
    document.getElementById('app-overlay').style.display = 'flex';
    document.body.style.overflow = 'hidden'; 
    
    document.getElementById('catalog-loader').style.display = 'flex';
    document.getElementById('loader-text').innerText = 'CARGANDO LIBRERÍAS...';
    document.getElementById('loader-status').innerText = 'Por favor, espera un momento.';
    
    const shifter = document.getElementById('magazine-shifter');
    shifter.innerHTML = '<div id="catalogo-app" style="opacity:0;"></div>';
    
    isMobileMode = window.innerWidth <= 768; 
    zoomLevel = 1; 
    currentTranslateX = isMobileMode ? 0 : -240; 
    actualizarLayout();

    try {
        if (typeof jQuery === 'undefined') {
            document.getElementById('loader-status').innerText = 'Descargando jQuery...';
            await cargarScript('https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js');
        }
        if (typeof jQuery.fn.turn === 'undefined') {
            document.getElementById('loader-status').innerText = 'Descargando Turn.js...';
            await cargarScript('https://cdnjs.cloudflare.com/ajax/libs/turn.js/3/turn.min.js');
        }
        
        document.getElementById('loader-text').innerText = 'OBTENIENDO PRODUCTOS...';
        document.getElementById('loader-status').innerText = 'Conectando con el inventario en tiempo real...';
        
        obtenerProductos(handle, imgP, imgC, titulo, tipoCatalogo);
        
    } catch (e) {
        document.getElementById('loader-text').innerHTML = '<span style="color:#e74c3c;">Fallo de Red</span>';
        document.getElementById('loader-status').innerText = 'No se pudo descargar la librería gráfica.';
    }
}

function cerrarCatalogo() {
    if (document.fullscreenElement) { document.exitFullscreen(); }
    document.getElementById('app-overlay').style.display = 'none';
    document.body.style.overflow = 'auto';
    
    if (typeof jQuery !== 'undefined' && jQuery('#catalogo-app').turn('is')) {
        jQuery('#catalogo-app').turn('destroy');
    }
    
    const shifter = document.getElementById('magazine-shifter');
    shifter.innerHTML = '<div id="catalogo-app"></div>';
    
    document.getElementById('mini-cart').classList.remove('open');
    const backdrop = document.getElementById('cart-backdrop');
    if(backdrop) { backdrop.classList.remove('show'); }
    
    document.getElementById('curr-page').innerText = '1';
    document.getElementById('total-pages').innerText = '-';

    fetch('/cart/clear.js', { method: 'POST' }).then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(e => console.error(e));

    if (typeof window.limpiarCarritoLocal === 'function') { window.limpiarCarritoLocal(); }
}

function volverACatalogos() {
    if (document.fullscreenElement) { document.exitFullscreen(); }
    document.getElementById('app-overlay').style.display = 'none';
    document.body.style.overflow = 'auto';
    
    if (typeof jQuery !== 'undefined' && jQuery('#catalogo-app').turn('is')) {
        jQuery('#catalogo-app').turn('destroy');
    }
    
    const shifter = document.getElementById('magazine-shifter');
    shifter.innerHTML = '<div id="catalogo-app"></div>';
    
    document.getElementById('mini-cart').classList.remove('open');
    const backdrop = document.getElementById('cart-backdrop');
    if(backdrop) { backdrop.classList.remove('show'); }
    
    document.getElementById('curr-page').innerText = '1';
    document.getElementById('total-pages').innerText = '-';

    localStorage.removeItem('tumatera_open_handle');
    localStorage.removeItem('tumatera_open_imgP');
    localStorage.removeItem('tumatera_open_imgC');
    localStorage.removeItem('tumatera_open_titulo');
}

function zoomCatalogo(amount) {
    zoomLevel += amount;
    if (zoomLevel < 1) zoomLevel = 1; 
    if (zoomLevel > 3.5) zoomLevel = 3.5;
    actualizarLayout();
}

function actualizarLayout() {
    const viewport = document.querySelector('.magazine-viewport');
    if(!viewport) return;

    let paddingX = window.innerWidth <= 768 ? 20 : 120;
    let paddingY = window.innerWidth <= 768 ? 130 : 180;

    let bookWidth = isMobileMode ? 480 : 960;
    let baseScale = Math.min((window.innerWidth - paddingX) / bookWidth, (window.innerHeight - paddingY) / 680);
    if (baseScale > 1) baseScale = 1;

    let finalScale = baseScale * zoomLevel;
    viewport.style.transform = `translate(-50%, -50%) scale(${finalScale})`;
    
    const shifter = document.getElementById('magazine-shifter');
    if(shifter) { shifter.style.transform = `translateX(${currentTranslateX}px)`; }
}

window.addEventListener('resize', () => { if (document.getElementById('app-overlay').style.display === 'flex') actualizarLayout(); });

function toggleFullscreen() {
    const overlay = document.getElementById('app-overlay');
    if (!document.fullscreenElement) { overlay.requestFullscreen().catch(err => {}); } 
    else { document.exitFullscreen(); }
}

function toggleCart() { 
    document.getElementById('mini-cart').classList.toggle('open'); 
    const backdrop = document.getElementById('cart-backdrop');
    if(backdrop) { backdrop.classList.toggle('show'); }
}

function mostrarErrorCarrito(mensaje) {
    const errorDiv = document.getElementById('cart-error-msg');
    if(errorDiv) {
        errorDiv.innerText = mensaje;
        errorDiv.style.display = 'block';
        document.getElementById('mini-cart').classList.add('open'); 
        const backdrop = document.getElementById('cart-backdrop');
        if(backdrop) { backdrop.classList.add('show'); }
        setTimeout(() => { errorDiv.style.display = 'none'; }, 4500); 
    }
}

async function agregarAlCarrito(id, titulo, sku, precio, img, maxStock, allowOversell, qtyToAdd) {
    const existingItem = localCart.find(item => item.id === id);
    const currentQty = existingItem ? existingItem.qty : 0;

    if (!allowOversell && maxStock !== null && (currentQty + qtyToAdd) > maxStock) {
        mostrarErrorCarrito(`¡Stock máximo alcanzado! Solo hay ${maxStock} unidades disponibles.`);
        return false;
    }
    
    if (existingItem) { 
        existingItem.qty += qtyToAdd; 
    } else { 
        localCart.push({ id, titulo, sku, precio: Number(precio), img, maxStock, allowOversell, qty: qtyToAdd }); 
    }
    
    actualizarMiniCarritoUI(); 
    animarBadgeCarrito(); 
    return true;
}

window.eliminarItemCarrito = function(id) {
    localCart = localCart.filter(item => item.id !== id);
    actualizarMiniCarritoUI();
};

async function cambiarQty(id, delta) {
    const item = localCart.find(i => i.id === id);
    if (!item) return;
    const newQty = item.qty + delta;
    
    if (delta > 0 && !item.allowOversell && item.maxStock !== null && newQty > item.maxStock) {
        mostrarErrorCarrito(`¡Límite alcanzado! Solo hay ${item.maxStock} unidades en inventario.`); return;
    }
    if (newQty <= 0) { localCart = localCart.filter(i => i.id !== id); } else { item.qty = newQty; }
    
    actualizarMiniCarritoUI();
}

async function escribirQtyCarrito(id, val) {
    let newQty = parseInt(val);
    if (isNaN(newQty) || newQty < 1) newQty = 1; 

    const item = localCart.find(i => i.id === id);
    if (!item) return;

    if (!item.allowOversell && item.maxStock !== null && newQty > item.maxStock) {
        mostrarErrorCarrito(`¡Límite alcanzado! Solo hay ${item.maxStock} unidades en inventario.`);
        newQty = item.maxStock; 
    }

    item.qty = newQty;
    actualizarMiniCarritoUI();
}

async function irAPagar() {
    if (localCart.length === 0) { mostrarErrorCarrito("Tu carrito está vacío."); return; }

    let subtotal = localCart.reduce((sum, i) => sum + (i.precio * i.qty), 0);

    if (window.modoGlobalCatalogo === 'b2b' && subtotal < TOPE_MINIMO_B2B) {
        let faltante = TOPE_MINIMO_B2B - subtotal;
        mostrarErrorCarrito(`El pedido mínimo B2B es de COP$${TOPE_MINIMO_B2B.toLocaleString('es-CO')}. Te faltan COP$${faltante.toLocaleString('es-CO')} para proceder.`);
        return;
    }

    let valorAsesora = '';
    if (window.modoGlobalCatalogo === 'b2b') {
        let selectAsesora = document.getElementById('cart-asesora');
        valorAsesora = selectAsesora ? selectAsesora.value.trim() : '';

        if (valorAsesora === '') {
            mostrarErrorCarrito("Por favor, selecciona qué asesora te atendió antes de ir a pagar.");
            return;
        }
    }

    const btn = document.querySelector('.btn-checkout');
    const oldText = btn.innerText;
    btn.innerText = 'PREPARANDO PEDIDO...';
    btn.style.opacity = '0.7'; 
    btn.style.pointerEvents = 'none';

    let itemsToSync = localCart.map(item => ({ 
        id: item.id.includes('gid://') ? item.id.split('/').pop() : item.id, 
        quantity: item.qty 
    }));
    
    let attributesToSync = { 'TipoPedido': window.modoGlobalCatalogo === 'b2b' ? 'Mayorista' : 'B2C' };
    
    if (valorAsesora !== '') {
        attributesToSync['Asesora'] = valorAsesora;
    }

    try {
        await fetch('/cart/clear.js', { method: 'POST' });
        
        const addResponse = await fetch('/cart/add.js', { 
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' }, 
            body: JSON.stringify({ items: itemsToSync }) 
        });

        if (!addResponse.ok) {
            throw new Error("Hubo un error al agregar los productos a Shopify.");
        }

        await fetch('/cart/update.js', { 
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' }, 
            body: JSON.stringify({ attributes: attributesToSync }) 
        });
        
        setTimeout(() => {
            btn.innerText = oldText;
            btn.style.opacity = '1';
            btn.style.pointerEvents = 'auto';
        }, 2000);

        window.location.href = '/checkout'; 

    } catch (error) {
        console.error(error);
        mostrarErrorCarrito("Hubo un problema al preparar tu pedido. Revisa tu conexión y stock.");
        btn.innerText = oldText; 
        btn.style.opacity = '1'; 
        btn.style.pointerEvents = 'auto';
    }
}

function actualizarMiniCarritoUI() {
    const container = document.getElementById('cart-items-container');
    const countBadge = document.getElementById('cart-count');
    const totalDisplay = document.getElementById('cart-total-price');
    const selectAsesora = document.getElementById('cart-asesora');
    const progressZone = document.getElementById('cart-progress-zone');

    if (selectAsesora && selectAsesora.parentElement) {
        selectAsesora.parentElement.style.display = (window.modoGlobalCatalogo === 'b2b') ? 'block' : 'none';
    }

    container.innerHTML = '';
    let total = 0; let totalItems = 0;

    if (localCart.length === 0) {
        container.innerHTML = ''; 
        if(progressZone) progressZone.style.display = 'none';
    } else {
        localCart.forEach(item => {
            total += (item.precio * item.qty); totalItems += item.qty;
            container.innerHTML += `
                <div class="cart-item">
                    <button class="btn-remove-item" onclick="eliminarItemCarrito('${item.id}')" title="Eliminar producto">
                        <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                    </button>
                    <div class="cart-item-img-wrap">
                        <img src="${item.img}" alt="${item.titulo}">
                    </div>
                    <div class="cart-item-details">
                        <div class="cart-item-header">
                            <div>
                                <h5 class="cart-item-title">${item.titulo}</h5>
                                <div class="cart-item-sku">SKU: ${item.sku}</div>
                            </div>
                        </div>
                        <div class="cart-item-bottom">
                            <div class="cart-item-price">COP$${item.precio.toLocaleString('es-CO')}</div>
                            <div class="qty-controls">
                                <button class="qty-btn" onclick="cambiarQty('${item.id}', -1)" aria-label="Reducir">-</button>
                                <input type="number" class="qty-input-cart" value="${item.qty}" min="1" onchange="escribirQtyCarrito('${item.id}', this.value)" aria-label="Escribir cantidad">
                                <button class="qty-btn" onclick="cambiarQty('${item.id}', 1)" aria-label="Aumentar">+</button>
                            </div>
                        </div>
                    </div>
                </div>`;
        });

        if(progressZone) {
            if (window.modoGlobalCatalogo === 'b2b') {
                progressZone.style.display = 'block';
                let metaEnvioB2B = 5000000; 
                let porcentaje = Math.min((total / metaEnvioB2B) * 100, 100);
                let faltante = metaEnvioB2B - total;
                
                if (total >= metaEnvioB2B) {
                    progressZone.innerHTML = `
                        <div class="cart-progress-text" style="color:#27ae60;">¡Felicidades! Tienes envío <strong>GRATIS</strong> (Bog/Sabana) ✨</div>
                        <div class="cart-progress-container"><div class="cart-progress-bar" style="width: 100%;"></div></div>`;
                } else {
                    progressZone.innerHTML = `
                        <div class="cart-progress-text">Te faltan <strong>COP$${faltante.toLocaleString('es-CO')}</strong> para envío GRATIS (Bog/Sabana)</div>
                        <div class="cart-progress-container"><div class="cart-progress-bar" style="width: ${porcentaje}%; background:#f39c12;"></div></div>`;
                }
            } else {
                progressZone.style.display = 'none';
                progressZone.innerHTML = '';
            }
        }

        if (window.modoGlobalCatalogo === 'b2b') {
            container.innerHTML += `
            <div style="margin-top:20px; padding-top:15px; border-top:1px solid #eee;">
                <div style="font-size: 10px; color: #555; line-height: 1.4; background: #f9f9f9; padding: 10px; border-radius: 6px; border: 1px solid #eee;">
                    <strong style="color:#111; display:block; margin-bottom:6px; font-size:11px;">Resumen Política B2B:</strong>
                    • <strong>Bogotá/Sabana:</strong> GRATIS desde $5M.<br>
                    • <strong>Medellín/Cali:</strong> GRATIS desde $10M.<br>
                    • <strong>Nacional:</strong> Contra entrega.<br>
                    <span style="font-size:9px; display:block; margin-top:6px; color:#e65525;">*Si no alcanzas el monto, aplica +10% y $10k en el Checkout.</span>
                </div>
            </div>
            `;
        }
    }
    countBadge.innerText = totalItems;
    totalDisplay.innerText = `COP$${total.toLocaleString('es-CO')}`;
}

function abrirModalVariantes(handle) {
    lastFocusedElement = document.activeElement; 
    const prod = catalogProductsMap[handle];
    if(!prod) return;
    
    modalCurrentHandle = handle;
    modalCurrentQty = 1;
    document.getElementById('modal-qty-input').value = modalCurrentQty;

    const errorDiv = document.getElementById('modal-error-msg');
    if(errorDiv) errorDiv.style.display = 'none';
    
    const validVariants = prod.variants.edges; 
    const swatchesContainer = document.getElementById('modal-swatches-container');
    
    let swatchesHtml = '';
    if(validVariants.length > 1) {
        validVariants.forEach((vEdge, index) => {
            const v = vEdge.node;
            const imgUrl = v.image?.url || prod.images.edges[0]?.node.url || '';
            const cleanVarId = v.id;
            
            swatchesHtml += `<button class="swatch-btn ${index === 0 ? 'active' : ''}" 
                aria-label="Seleccionar color: ${v.title.replace(/'/g, "\\'")}" 
                style="background-image: url('${imgUrl}')" 
                onclick="seleccionarVarianteModal(this, '${cleanVarId}')">
            </button>`;
        });
    }
    swatchesContainer.innerHTML = swatchesHtml;
    
    const defaultVarId = validVariants[0].node.id;
    seleccionarVarianteModal(swatchesContainer.querySelector('.swatch-btn') || null, defaultVarId);
    
    const modalOverlay = document.getElementById('variant-modal-overlay');
    modalOverlay.classList.add('show');
    
    setTimeout(() => { document.querySelector('.btn-close-modal').focus(); }, 100);
}

function seleccionarVarianteModal(btnEl, variantId) {
    if(btnEl) {
        const swatches = document.getElementById('modal-swatches-container').querySelectorAll('.swatch-btn');
        swatches.forEach(b => b.classList.remove('active'));
        btnEl.classList.add('active');
    }
    
    modalCurrentVarId = variantId;
    const prod = catalogProductsMap[modalCurrentHandle];
    const vEdge = prod.variants.edges.find(e => e.node.id === variantId);
    const v = vEdge.node;
    
    const imgUrl = v.image?.url || prod.images.edges[0]?.node.url || '';
    document.getElementById('modal-img').src = imgUrl;
    
    const varSuffix = prod.variants.edges.length > 1 ? ` - ${v.title}` : '';
    document.getElementById('modal-title').innerText = `${prod.title}${varSuffix}`;
    
    let precioNormal = Number(v.price.amount);
    let compPrice = v.compareAtPrice ? Number(v.compareAtPrice.amount) : null;
    
    const isFora = esProductoFora(prod);
    const multiplier = isFora ? 0.80 : 0.60;
    
    let base = compPrice !== null ? compPrice : precioNormal;
    modalCurrentUnitPrice = window.modoGlobalCatalogo === 'b2b' ? Math.round(base * multiplier) : Math.round(precioNormal);
    
    const isAvailable = v.availableForSale;
    const qty = v.quantityAvailable;
    const stockBadge = document.getElementById('modal-stock-badge');
    const deliveryInfo = document.getElementById('modal-delivery-info');
    
    if (qty !== null && qty !== undefined) {
        if (qty > 0) { 
            stockBadge.className = 'modal-stock-badge'; 
            stockBadge.innerHTML = `STOCK: ${qty}`; 
            stockBadge.style.background = '#27ae60'; 
            deliveryInfo.innerHTML = '<strong>Entrega estimada:</strong> 3 a 5 días hábiles.<br><span style="font-size: 8.5px;">(Sujeto a disponibilidad del pedido.)</span>';
        }
        else if (qty <= 0 && isAvailable) { 
            stockBadge.className = 'modal-stock-badge'; 
            stockBadge.innerHTML = `<svg viewBox="0 0 24 24" width="12" height="12" stroke="currentColor" stroke-width="2" fill="none" style="vertical-align: middle; margin-right: 4px; margin-top:-2px;"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>BAJO PEDIDO`; 
            stockBadge.style.background = '#f39c12'; 
            deliveryInfo.innerHTML = '<strong>Entrega estimada:</strong> 15 a 30 días hábiles.<br><span style="font-size: 8.5px;">(Tiempos sujetos a fabricación.)</span>';
        }
        else { 
            stockBadge.className = 'modal-stock-badge agotado'; 
            stockBadge.innerHTML = 'AGOTADO'; 
            stockBadge.style.background = '#e74c3c'; 
            deliveryInfo.innerHTML = '';
        }
    } else {
        stockBadge.className = isAvailable ? 'modal-stock-badge' : 'modal-stock-badge agotado';
        stockBadge.innerHTML = isAvailable ? 'DISPONIBLE' : 'AGOTADO';
        stockBadge.style.background = isAvailable ? '#27ae60' : '#e74c3c';
        deliveryInfo.innerHTML = isAvailable ? '<strong>Entrega estimada:</strong> 3 a 5 días hábiles.<br><span style="font-size: 8.5px;">(Sujeto a disponibilidad del pedido.)</span>' : '';
    }
    
    const errorDiv = document.getElementById('modal-error-msg');
    if(errorDiv) errorDiv.style.display = 'none';

    modalCurrentQty = 1;
    document.getElementById('modal-qty-input').value = modalCurrentQty;
    actualizarPrecioModal();
}

function cambiarQtyModal(delta) {
    const prod = catalogProductsMap[modalCurrentHandle];
    const vEdge = prod.variants.edges.find(e => e.node.id === modalCurrentVarId);
    const v = vEdge.node;
    const maxStock = v.quantityAvailable;
    const allowOversell = (maxStock === null || (maxStock <= 0 && v.availableForSale));
    
    const existingItem = localCart.find(item => item.id === modalCurrentVarId);
    const inCartQty = existingItem ? existingItem.qty : 0;
    
    let newQty = modalCurrentQty + delta;
    if (newQty < 1) newQty = 1;
    
    const errorDiv = document.getElementById('modal-error-msg');

    if (!allowOversell && maxStock !== null && (newQty + inCartQty) > maxStock) {
        errorDiv.innerText = `Límite de stock: Tienes ${inCartQty} en el carrito y quedan ${maxStock} en inventario.`;
        errorDiv.style.display = 'block';
        setTimeout(() => { errorDiv.style.display = 'none'; }, 5000); 
        return;
    } else {
        if(errorDiv) errorDiv.style.display = 'none';
    }
    
    modalCurrentQty = newQty;
    document.getElementById('modal-qty-input').value = modalCurrentQty;
    actualizarPrecioModal();
}

function escribirQtyModal(val) {
    let newQty = parseInt(val);
    if (isNaN(newQty) || newQty < 1) newQty = 1; 

    const prod = catalogProductsMap[modalCurrentHandle];
    const vEdge = prod.variants.edges.find(e => e.node.id === modalCurrentVarId);
    const v = vEdge.node;
    const maxStock = v.quantityAvailable;
    const allowOversell = (maxStock === null || (maxStock <= 0 && v.availableForSale));
    
    const existingItem = localCart.find(item => item.id === modalCurrentVarId);
    const inCartQty = existingItem ? existingItem.qty : 0;
    
    const errorDiv = document.getElementById('modal-error-msg');

    if (!allowOversell && maxStock !== null && (newQty + inCartQty) > maxStock) {
        errorDiv.innerText = `Límite de stock: Tienes ${inCartQty} en el carrito y quedan ${maxStock} en inventario.`;
        errorDiv.style.display = 'block';
        setTimeout(() => { errorDiv.style.display = 'none'; }, 5000);
        
        newQty = maxStock - inCartQty; 
        if (newQty < 1) newQty = 1;
    } else {
        if(errorDiv) errorDiv.style.display = 'none';
    }
    
    modalCurrentQty = newQty;
    document.getElementById('modal-qty-input').value = modalCurrentQty;
    actualizarPrecioModal();
}

function actualizarPrecioModal() {
    const totalCalc = modalCurrentUnitPrice * modalCurrentQty;
    let priceHtml = `COP$${totalCalc.toLocaleString('es-CO')}`;

    const prod = catalogProductsMap[modalCurrentHandle];
    const vEdge = prod.variants.edges.find(e => e.node.id === modalCurrentVarId);
    const v = vEdge.node;
    let precioNormal = Number(v.price.amount);
    let compPrice = v.compareAtPrice ? Number(v.compareAtPrice.amount) : null;

    if (window.modoGlobalCatalogo === 'b2b') {
        const isFora = esProductoFora(prod);
        const discountText = isFora ? '-20%' : '-40%';
        let base = compPrice !== null ? compPrice : precioNormal;
        let totalBase = Math.round(base) * modalCurrentQty;
        priceHtml = `<span style="text-decoration:line-through; color:#999; font-size:14px; margin-right:5px;">$${totalBase.toLocaleString('es-CO')}</span> <span style="background:#e74c3c; color:#fff; font-size:12px; padding:2px 6px; border-radius:4px; margin-right:5px;">${discountText}</span> COP$${totalCalc.toLocaleString('es-CO')}`;
    } else if (compPrice !== null && compPrice > precioNormal) {
        let totalBase = Math.round(compPrice) * modalCurrentQty;
        priceHtml = `<span style="text-decoration:line-through; color:#999; font-size:14px; margin-right:5px;">$${totalBase.toLocaleString('es-CO')}</span> COP$${totalCalc.toLocaleString('es-CO')}`;
    }
    
    document.getElementById('modal-price').innerHTML = priceHtml;
}

async function agregarDesdeModal() {
    const prod = catalogProductsMap[modalCurrentHandle];
    const vEdge = prod.variants.edges.find(e => e.node.id === modalCurrentVarId);
    const v = vEdge.node;
    
    const sku = v.sku || 'Sin SKU';
    const varSuffix = prod.variants.edges.length > 1 ? ` - ${v.title}` : '';
    const titulo = `${prod.title}${varSuffix}`;
    const imgUrl = v.image?.url || prod.images.edges[0]?.node.url || '';
    const maxStock = v.quantityAvailable;
    const allowOversell = (maxStock === null || (maxStock <= 0 && v.availableForSale));
    
    const btn = document.getElementById('modal-add-btn');
    btn.innerText = 'AGREGANDO...';
    btn.style.pointerEvents = 'none';
    
    const exito = await agregarAlCarrito(modalCurrentVarId, titulo, sku, modalCurrentUnitPrice, imgUrl, maxStock, allowOversell, modalCurrentQty);
    
    btn.innerText = 'AGREGAR AL CARRITO';
    btn.style.pointerEvents = 'auto';
    
    if(exito) {
        cerrarModalVariantes();
        document.getElementById('mini-cart').classList.add('open');
        const backdrop = document.getElementById('cart-backdrop');
        if(backdrop) { backdrop.classList.add('show'); }
    }
}

function cerrarModalVariantes() {
    const modal = document.getElementById('variant-modal-overlay');
    modal.style.animation = "modalFadeOut 0.3s forwards";
    modal.querySelector('.variant-modal-box').style.animation = "modalPopOut 0.3s forwards";
    
    setTimeout(() => {
        modal.classList.remove('show');
        modal.style.animation = "";
        modal.querySelector('.variant-modal-box').style.animation = "";
        if (lastFocusedElement) { lastFocusedElement.focus(); }
    }, 300);
}

function centrarLibro(page, totalPages) {
    if (isMobileMode) {
        currentTranslateX = 0; 
    } else {
        if (page === 1) { currentTranslateX = -240; } 
        else if (page === totalPages || (page === totalPages - 1 && totalPages % 2 === 0)) { currentTranslateX = 240; } 
        else { currentTranslateX = 0; }
    }
    
    const shifter = document.getElementById('magazine-shifter');
    if(shifter) { shifter.style.transform = `translateX(${currentTranslateX}px)`; }
}

function iniciarRevista() {
    try {
        document.getElementById('loader-status').innerText = 'Descargando productos...';

        jQuery("#catalogo-app").turn({
            width: isMobileMode ? 480 : 960, height: 680, autoCenter: false, 
            display: isMobileMode ? 'single' : 'double', acceleration: true, elevation: 50, gradients: true, duration: 1000, 
            when: {
                turning: function(e, page, view) { centrarLibro(page, jQuery(this).turn('pages')); },
                turned: function(e, page, view) { document.getElementById('curr-page').innerText = page; }
            }
        });

        setTimeout(() => {
            const totalPages = jQuery("#catalogo-app").turn("pages");
            document.getElementById('total-pages').innerText = totalPages;
            centrarLibro(jQuery("#catalogo-app").turn("page"), totalPages); 
            document.getElementById('catalog-loader').style.display = 'none';
            document.getElementById('catalogo-app').style.opacity = '1';
        }, 300); 

    } catch (error) {
        document.getElementById('loader-text').innerHTML = '<span style="color:#e74c3c;">Ocurrió un error inesperado.</span>';
        document.getElementById('loader-status').innerText = 'Intenta cerrar el visor y abrirlo de nuevo.';
    }
}

function renderizarRevista(productos, imgP, imgC, titulo, tipoCatalogo) {
    const contenedor = document.getElementById('catalogo-app');
    document.getElementById('loader-status').innerText = 'Estructurando páginas...';
    
    catalogProductsMap = {}; 
    let productosValidos = [];
    
    productos.forEach(e => {
        let variantesValidas = e.node.variants.edges.filter(vEdge => vEdge.node.availableForSale);
        if (variantesValidas.length > 0) { e.node.variants.edges = variantesValidas; catalogProductsMap[e.node.handle] = e.node; productosValidos.push(e); }
    });

    let paginasArray = [];
    paginasArray.push(`<div class="pagina hard"><img src="${imgP}" style="width:100%;height:100%;object-fit:cover;" alt="Portada"></div>`);
    if (!isMobileMode) { paginasArray.push(`<div class="pagina hard"></div>`); }

    const PRODS_PAGINA = 9;
    for (let i = 0; i < productosValidos.length; i += PRODS_PAGINA) {
        const sub = productosValidos.slice(i, i + PRODS_PAGINA);
        
        let gridHtml = `<div class="pagina">
            <div style="text-align:center; border-bottom:1px solid #eee; margin-bottom:6px; padding:8px 0 4px 0;">
                <span style="font-size:11px; font-weight:bold; color:#e65525; text-transform:uppercase;">${titulo} ${tipoCatalogo === 'b2b' ? '(MAYORISTA)' : ''}</span>
            </div>
            <div class="grid-productos">`;
            
        sub.forEach(e => {
            const v = e.node.variants.edges[0].node; 
            const handle = e.node.handle;

            let imgUrl = '';
            const imgEdges = e.node.images.edges;
            const img01 = imgEdges.find(i => i.node.url.includes('_01'));
            if (img01) { imgUrl = img01.node.url; } else { imgUrl = v.image?.url || imgEdges[0]?.node.url || ''; }

            const stockLevel = v.quantityAvailable;
            const isAvailable = v.availableForSale;
            let stockHtml = '';

            if (stockLevel !== null && stockLevel !== undefined) {
                if (stockLevel > 0) {
                    stockHtml = `<div class="stock-badge">STOCK: ${stockLevel}</div>`;
                } else if (stockLevel <= 0 && isAvailable) {
                    stockHtml = `<div class="stock-badge bajo-pedido"><svg viewBox="0 0 24 24" width="10" height="10" stroke="currentColor" stroke-width="2" fill="none"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>BAJO PEDIDO</div>`;
                } else {
                    stockHtml = `<div class="stock-badge agotado">AGOTADO</div>`;
                }
            } else {
                stockHtml = isAvailable ? `<div class="stock-badge">DISPONIBLE</div>` : `<div class="stock-badge agotado">AGOTADO</div>`;
            }

            const allVariants = e.node.variants.edges;
            let btnText = allVariants.length > 1 ? "ELEGIR OPCIÓN" : "AGREGAR";

            const precioNormal = Number(v.price.amount);
            const precioComparacion = v.compareAtPrice ? Number(v.compareAtPrice.amount) : null;
            let precioFinalHtml = '';

            if (tipoCatalogo === 'b2b') {
                let isFora = esProductoFora(e.node);
                let multiplier = isFora ? 0.80 : 0.60;
                let discountText = isFora ? '-20%' : '-40%';
                
                let precioBase = (precioComparacion !== null) ? precioComparacion : precioNormal;
                let precioFinal = Math.round(precioBase * multiplier);
                precioFinalHtml = `
                    <div style="display:flex; flex-direction:column; align-items:center; margin-bottom:4px; line-height:1.1;">
                        <div style="display:flex; align-items:center; gap:5px;">
                            <span style="text-decoration:line-through; color:#999; font-size:10px;">$${precioBase.toLocaleString('es-CO')}</span>
                            <span style="background:#e74c3c; color:#fff; font-size:9px; font-weight:bold; padding:2px 4px; border-radius:4px;">${discountText}</span>
                        </div>
                        <div style="margin-bottom:0; font-size:12px; margin-top:2px; font-weight:700;">COP$${precioFinal.toLocaleString('es-CO')}</div>
                    </div>`;
            } else {
                let precioFinal = Math.round(precioNormal);
                if (precioComparacion !== null && precioComparacion > precioNormal) {
                    precioFinalHtml = `
                    <div style="display:flex; flex-direction:column; align-items:center; margin-bottom:4px; line-height:1.1;">
                        <span style="text-decoration:line-through; color:#999; font-size:10px;">$${precioComparacion.toLocaleString('es-CO')}</span>
                        <div style="margin-bottom:0; font-size:12px; margin-top:2px; font-weight:bold; color:#e65525;">COP$${precioFinal.toLocaleString('es-CO')}</div>
                    </div>`;
                } else {
                    precioFinalHtml = `<div style="margin-bottom:4px; font-size:12px; font-weight:bold; color:#e65525;">COP$${precioFinal.toLocaleString('es-CO')}</div>`;
                }
            }

            const imgHeight = (tipoCatalogo === 'b2b') ? '75px' : '85px';

            gridHtml += `
                <div class="item-producto" role="button" tabindex="0" onclick="abrirModalVariantes('${handle}')" onkeydown="if(event.key==='Enter' || event.key===' ') { event.preventDefault(); abrirModalVariantes('${handle}'); }">
                    ${stockHtml}
                    <div class="item-producto-btn-area">
                        <img src="${imgUrl}" class="item-img" id="img-${handle}" alt="${e.node.title}" style="height: ${imgHeight};">
                        <h4 class="titulo-prod">${e.node.title}</h4>
                    </div>
                    
                    <div style="width: 100%; margin-top: auto; padding-top: 6px; padding-bottom: 2px;">
                        ${precioFinalHtml}
                        <button class="btn-add" tabindex="-1">${btnText}</button>
                    </div>
                </div>`;
        });
        gridHtml += `</div></div>`;
        paginasArray.push(gridHtml);
    }

    if (!isMobileMode) {
        if (paginasArray.length % 2 === 0) { paginasArray.push(`<div class="pagina" style="background:#fff;"></div>`); }
    }

    paginasArray.push(`<div class="pagina hard"><img src="${imgC}" style="width:100%;height:100%;object-fit:cover;" alt="Contraportada"></div>`);
    
    contenedor.innerHTML = paginasArray.join('');

    requestAnimationFrame(() => {
        iniciarRevista();
    });
}

async function obtenerProductos(handle, imgP, imgC, titulo, tipoCatalogo) {
    try {
        const query = `
        {
          collection(handle: "${handle}") {
            products(first: 250) {
              edges {
                node {
                  handle
                  title
                  tags
                  images(first: 2) {
                    edges {
                      node {
                        url
                      }
                    }
                  }
                  variants(first: 50) {
                    edges {
                      node {
                        id
                        title
                        sku
                        availableForSale
                        quantityAvailable
                        price { amount }
                        compareAtPrice { amount }
                        image { url }
                      }
                    }
                  }
                }
              }
            }
          }
        }`;

        const res = await fetch(SHOP_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': ST_TOKEN
            },
            body: JSON.stringify({ query })
        });

        const json = await res.json();
        
        if (json.errors) {
            console.error("GraphQL Errors:", json.errors);
            throw new Error("Permiso de inventario denegado en la API.");
        }
        
        if (json.data && json.data.collection && json.data.collection.products.edges.length > 0) {
            globalCatalogData = {
                productos: json.data.collection.products.edges,
                imgP: imgP,
                imgC: imgC,
                titulo: titulo,
                tipoCatalogo: tipoCatalogo
            };
            
            renderizarRevista(globalCatalogData.productos, imgP, imgC, titulo, tipoCatalogo);
        } else {
            throw new Error("Colección vacía o error de permisos GraphQL.");
        }
    } catch (errorGraphQL) { 
        console.warn("Intento con GraphQL falló, cargando API antigua de emergencia.", errorGraphQL);
        
        try {
            const resAjax = await fetch(`/collections/${handle}/products.json?limit=250`);
            const jsonAjax = await resAjax.json();
            
            if (jsonAjax.products && jsonAjax.products.length > 0) {
                const productosTransformados = jsonAjax.products.map(p => {
                    return {
                        node: {
                            handle: p.handle, title: p.title, tags: p.tags,
                            images: { edges: p.images.map(img => ({ node: { url: img.src } })) },
                            variants: {
                                edges: p.variants.map(v => ({
                                    node: {
                                        id: `gid://shopify/ProductVariant/${v.id}`,
                                        title: v.title, sku: v.sku, availableForSale: v.available,
                                        quantityAvailable: null, 
                                        price: { amount: v.price }, compareAtPrice: v.compare_at_price ? { amount: v.compare_at_price } : null,
                                        image: v.featured_image ? { url: v.featured_image.src } : null
                                    }
                                }))
                            }
                        }
                    };
                });

                globalCatalogData = { productos: productosTransformados, imgP: imgP, imgC: imgC, titulo: titulo, tipoCatalogo: tipoCatalogo };
                renderizarRevista(globalCatalogData.productos, imgP, imgC, titulo, tipoCatalogo);
            } else {
                document.getElementById('loader-text').innerHTML = '<span style="color:#e74c3c;">El catálogo está vacío.</span>';
            }
        } catch (errorAjax) {
            document.getElementById('loader-text').innerHTML = '<span style="color:#e74c3c;">Error de conexión.</span>'; 
        }
    }
}

async function generarYDescargarPDF() {
    if (!globalCatalogData || typeof html2canvas === 'undefined' || typeof window.jspdf === 'undefined') {
        alert("Las herramientas de PDF aún se están cargando...");
        return;
    }

    window.scrollTo(0, 0);

    const loader = document.getElementById('catalog-loader');
    loader.style.zIndex = '9999999'; 
    loader.style.display = 'flex';
    
    document.getElementById('loader-text').innerText = 'PREPARANDO PDF...';
    document.getElementById('loader-status').innerText = 'Construyendo páginas...';

    const pdfContainer = document.createElement('div');
    pdfContainer.id = 'pdf-container-temp';
    pdfContainer.style.cssText = `position: absolute; top: 0; left: -9999px; width: 800px; background: #fff; z-index: -1;`;
    document.body.appendChild(pdfContainer);

    try {
        let productosValidos = [];
        globalCatalogData.productos.forEach(e => {
            let variantesValidas = e.node.variants.edges.filter(vEdge => vEdge.node.availableForSale);
            if (variantesValidas.length > 0) {
                e.node.variants.edges = variantesValidas;
                productosValidos.push(e);
            }
        });

        let tituloVisual = globalCatalogData.titulo;
        if (globalCatalogData.tipoCatalogo === 'b2b') {
            tituloVisual += ' (MAYORISTA)';
        }

        let pdfHtml = '';
        
        let portadaUrl = globalCatalogData.imgP;
        pdfHtml += `<div class="pdf-snapshot" style="width:800px; height:1130px; background:#fff; overflow:hidden; position:relative;"><img src="${portadaUrl}" crossorigin="anonymous" style="width:100%;height:100%;object-fit:cover;display:block;"></div>`;

        const PRODS_PAGINA = 9;
        for (let i = 0; i < productosValidos.length; i += PRODS_PAGINA) {
            const sub = productosValidos.slice(i, i + PRODS_PAGINA);
            
            pdfHtml += `<div class="pdf-snapshot" style="width:800px; height:1130px; padding:40px 50px; box-sizing:border-box; background:#fff; position:relative; overflow:hidden; display:flex; flex-direction:column;">
                <h2 style="text-align:center; color:#e65525; margin:0 0 30px 0; font-family:sans-serif; text-transform:uppercase; font-size:24px; width:100%; height:30px;">${tituloVisual}</h2>
                <div style="display:flex; flex-wrap:wrap; gap:20px; justify-content:center; align-items:flex-start; align-content:flex-start; width:100%; flex-grow:1;">`;

            sub.forEach(e => {
                const v = e.node.variants.edges[0].node;
                
                let imgUrl = '';
                const imgEdges = e.node.images.edges;
                const img01 = imgEdges.find(i => i.node.url.includes('_01'));
                if (img01) { imgUrl = img01.node.url; } else { imgUrl = imgEdges[0]?.node.url || ''; }

                const productUrl = new URL(`/products/${e.node.handle}`, window.location.origin).href;
                const precioNormal = Number(v.price.amount);
                const precioComparacion = v.compareAtPrice ? Number(v.compareAtPrice.amount) : null;
                
                let htmlPrecio = '';
                if (globalCatalogData.tipoCatalogo === 'b2b') {
                    let isFora = esProductoFora(e.node);
                    let multiplier = isFora ? 0.80 : 0.60;
                    let discountText = isFora ? '-20%' : '-40%';
                    let precioBase = (precioComparacion !== null) ? precioComparacion : precioNormal;
                    let precioFinal = Math.round(precioBase * multiplier);
                    htmlPrecio = `<div style="line-height:1.1; margin-bottom:6px;">
                        <div style="display:flex; justify-content:center; align-items:center; gap:5px; margin-bottom:4px;">
                            <span style="text-decoration:line-through; color:#999; font-size:12px;">$${precioBase.toLocaleString('es-CO')}</span>
                            <span style="background:#e74c3c; color:#fff; font-size:10px; font-weight:bold; padding:2px 5px; border-radius:4px;">${discountText}</span>
                        </div>
                        <div style="font-size:16px; font-weight:bold; color:#555;">COP$${precioFinal.toLocaleString('es-CO')}</div>
                    </div>`;
                } else {
                    let precioFinal = Math.round(precioNormal);
                    if (precioComparacion !== null && precioComparacion > precioNormal) {
                        htmlPrecio = `<div style="line-height:1.1; margin-bottom:6px;">
                            <div style="display:flex; justify-content:center; align-items:center; margin-bottom:4px;">
                                <span style="text-decoration:line-through; color:#999; font-size:12px;">$${precioComparacion.toLocaleString('es-CO')}</span>
                            </div>
                            <div style="font-size:16px; font-weight:bold; color:#e65525;">COP$${precioFinal.toLocaleString('es-CO')}</div>
                        </div>`;
                    } else {
                        htmlPrecio = `<div style="font-size:16px; font-weight:bold; color:#e65525; margin-bottom:6px; margin-top:16px;">COP$${precioFinal.toLocaleString('es-CO')}</div>`;
                    }
                }
                
                pdfHtml += `<div class="pdf-product-link" data-url="${productUrl}" style="width:215px; height:310px; border:1px solid #ddd; border-radius:8px; padding:12px; box-sizing:border-box; text-align:center; font-family:sans-serif; background:#fff; display:flex; flex-direction:column; align-items:center; justify-content:space-between;">
                    <div style="width:100%; height:140px; display:flex; align-items:center; justify-content:center; margin-bottom:8px;">
                        <img src="${imgUrl}" crossorigin="anonymous" style="max-width:100%; max-height:100%; object-fit:contain; display:block;">
                    </div>
                    <div style="width:100%;">
                        <div style="font-size:15px; font-weight:bold; color:#5e5b5b; height:36px; overflow:hidden; line-height:1.2; width:100%; margin-bottom:4px;">${e.node.title}</div>
                        <div style="font-size:12px; color:#777; margin-bottom:6px;">SKU: ${v.sku || 'N/A'}</div>
                    </div>
                    <div style="width:100%;">
                        ${htmlPrecio}
                        <div style="background:#e65525; color:#fff; padding:8px; border-radius:6px; font-weight:bold; font-size:11px; text-transform:uppercase; margin-top:auto; width:100%; box-sizing:border-box;">VER EN TIENDA</div>
                    </div>
                </div>`;
            });
            pdfHtml += `</div></div>`;
        }

        let contraUrl = globalCatalogData.imgC;
        pdfHtml += `<div class="pdf-snapshot" style="width:800px; height:1130px; background:#fff; overflow:hidden; position:relative;"><img src="${contraUrl}" crossorigin="anonymous" style="width:100%;height:100%;object-fit:cover;display:block;"></div>`;
        
        pdfContainer.innerHTML = pdfHtml;

        const imagesToLoad = Array.from(pdfContainer.querySelectorAll('img'));
        await Promise.all(imagesToLoad.map(img => new Promise(res => {
            if (img.complete) res(); 
            else { 
                img.onload = res; 
                img.onerror = () => res();
            }
        })));

        const { jsPDF } = window.jspdf;
        const pdf = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4' }); 
        const pdfWidth = 210;
        const pdfHeight = 297;
        const pagesToCapture = pdfContainer.querySelectorAll('.pdf-snapshot');
        const totalPgs = pagesToCapture.length;

        for (let i = 0; i < totalPgs; i++) {
            let porcentaje = Math.round(((i + 1) / totalPgs) * 100);
            document.getElementById('loader-status').innerText = `Procesando página ${i + 1} de ${totalPgs}... (${porcentaje}%)`;
            
            const pageEl = pagesToCapture[i];
            
            const canvas = await html2canvas(pageEl, { 
                scale: 2, 
                useCORS: true, 
                logging: false, 
                backgroundColor: '#ffffff',
                onclone: (clonedDoc) => {
                    const stylesheets = clonedDoc.querySelectorAll('style, link[rel="stylesheet"]');
                    stylesheets.forEach(el => el.remove());
                }
            });
            
            const imgData = canvas.toDataURL('image/jpeg', 0.9);
            if (i > 0) pdf.addPage();
            pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);

            const links = pageEl.querySelectorAll('.pdf-product-link');
            links.forEach(link => {
                const url = link.getAttribute('data-url');
                const x = (link.offsetLeft / 800) * pdfWidth;
                const y = (link.offsetTop / 1130) * pdfHeight;
                const w = (link.offsetWidth / 800) * pdfWidth;
                const h = (link.offsetHeight / 1130) * pdfHeight;
                pdf.link(x, y, w, h, { url: url });
            });
        }

        pdf.setDisplayMode('fullpage', 'continuous');
        
        let nombreArchivoFinal = globalCatalogData.titulo.replace(/\s+/g, '_');
        if (globalCatalogData.tipoCatalogo === 'b2b') nombreArchivoFinal += '_MAYORISTA';
        const finalName = `Catalogo_${nombreArchivoFinal}.pdf`;

        const pdfBlob = pdf.output('blob');

        if (isMobileMode) {
            document.getElementById('loader-status').innerText = '¡100% Completado! Abriendo archivo...';
            
            const file = new File([pdfBlob], finalName, { type: 'application/pdf' });
            
            if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
                try {
                    await navigator.share({
                        files: [file],
                        title: 'Catálogo Tumatera',
                    });
                } catch (err) {
                    const blobUrl = URL.createObjectURL(pdfBlob);
                    window.location.href = blobUrl;
                }
            } else {
                const blobUrl = URL.createObjectURL(pdfBlob);
                window.location.href = blobUrl;
            }
        } else {
            document.getElementById('loader-status').innerText = '¡100% Completado! Iniciando descarga...';
            pdf.save(finalName);
        }

    } catch (error) {
        console.error("Error detallado al generar PDF:", error);
        alert("Error técnico al crear PDF: " + (error.message || "Fallo desconocido") + "\n\nPor favor envía captura de este mensaje para soporte.");
    } finally {
        if(document.body.contains(pdfContainer)) {
            document.body.removeChild(pdfContainer);
        }
        loader.style.zIndex = '40'; 
        loader.style.display = 'none';
    }
}